import {Component, OnDestroy, OnInit} from '@angular/core';
import {WarningPageBase} from '../../general/WarningPageBase';
import {AppService} from '../../../services/app.service';

@Component({
	selector: 'app-tur-warning',
	templateUrl: './tur-warning.component.html',
	styleUrls: ['./tur-warning.component.scss']
})
export class TurWarningComponent extends WarningPageBase implements OnInit, OnDestroy {

	constructor(app: AppService) {
		super(app);
	}
}
